import React from "react";
import { dollars } from "LIB/formatters/currency";
import { Link } from "react-router-dom";
import { NoteTooltip } from "MODULES/shared/components";
import { Detail as TableRowDetail } from "MODULES/shared/components/DetailTable";
import {
  LIABILITIES_OWED,
  PURCHASES_OWED,
  REPAIR_LIABILITIES_OWED
} from "MODULES/companies/constants";

export function Liabilities({ company }) {
  return [
    <table className="table table-condensed">
      <tbody>
        <TableRowDetail
          label="We Currently Owe"
          value={dollars(
            Number(company.get(LIABILITIES_OWED)) +
              Number(company.get(REPAIR_LIABILITIES_OWED))
          )}
        />
      </tbody>
    </table>,
    <table>
      <tbody>
        <tr>
          <td style={{ textAlign: "center", padding: "0 10px" }}>
            <Link
              className="btn btn-xs btn-block btn-default"
              style={{ minWidth: "80px" }}
              to={`/purchase-orders?not_paid=true&page=1&filter=${company.get(
                "name"
              )}`}
            >
              Purchases&nbsp;{
                <span className="text-right">
                  <NoteTooltip
                    placement="right"
                    icon="fa-info-circle"
                    color="rgba(255, 255, 255, 0.25)"
                    note={dollars(company.get(PURCHASES_OWED), 0)}
                  />
                </span>
              }
            </Link>
          </td>
          <td style={{ textAlign: "center", padding: "0 10px" }}>
            <Link
              className="btn btn-xs btn-block btn-default"
              style={{ minWidth: "80px" }}
              to={`/repair-orders?invoice_unpaid=true&cancelled=false&page=1&filter=${company.get(
                "name"
              )}`}
            >
              Repairs&nbsp;{
                <span className="text-right">
                  <NoteTooltip
                    placement="right"
                    icon="fa-info-circle"
                    color="rgba(255, 255, 255, 0.25)"
                    note={dollars(company.get(REPAIR_LIABILITIES_OWED), 0)}
                  />
                </span>
              }
            </Link>
          </td>
          <td style={{ textAlign: "center", padding: "0 10px" }}>
            <Link
              style={{ minWidth: "80px" }}
              className="btn btn-xs btn-block btn-default"
              to={`/lots?invoiced=false&filter=${company.get("name")}`}
            >
              Lot Charges&nbsp;{
                <span className="text-right">
                  <NoteTooltip
                    placement="right"
                    icon="fa-info-circle"
                    color="rgba(255, 255, 255, 0.25)"
                    note={dollars(company.get("lot_charges"), 0)}
                  />
                </span>
              }
            </Link>
          </td>
        </tr>
      </tbody>
    </table>
  ];
}



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/Liabilities/Liabilities.jsx